import { render, staticRenderFns } from "./IdeaCreator.vue?vue&type=template&id=4fe38567&scoped=true"
import script from "./IdeaCreator.vue?vue&type=script&lang=js"
export * from "./IdeaCreator.vue?vue&type=script&lang=js"
import style0 from "./IdeaCreator.vue?vue&type=style&index=0&id=4fe38567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe38567",
  null
  
)

export default component.exports